/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current: NonNullable<unknown>, total: NonNullable<unknown> }} Event_Group_Sync_Status_ProgressInputs */

const en_event_group_sync_status_progress = /** @type {(inputs: Event_Group_Sync_Status_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Syncing event ${i?.current}/${i?.total}`)
};

const fr_event_group_sync_status_progress = /** @type {(inputs: Event_Group_Sync_Status_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Syncing event ${i?.current}/${i?.total}`)
};

const de_event_group_sync_status_progress = /** @type {(inputs: Event_Group_Sync_Status_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Syncing event ${i?.current}/${i?.total}`)
};

const it_event_group_sync_status_progress = /** @type {(inputs: Event_Group_Sync_Status_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Syncing event ${i?.current}/${i?.total}`)
};

const ru_event_group_sync_status_progress = /** @type {(inputs: Event_Group_Sync_Status_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Syncing event ${i?.current}/${i?.total}`)
};

const es_event_group_sync_status_progress = /** @type {(inputs: Event_Group_Sync_Status_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Syncing event ${i?.current}/${i?.total}`)
};

const zh_cn2_event_group_sync_status_progress = /** @type {(inputs: Event_Group_Sync_Status_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Syncing event ${i?.current}/${i?.total}`)
};

const ja_event_group_sync_status_progress = /** @type {(inputs: Event_Group_Sync_Status_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Syncing event ${i?.current}/${i?.total}`)
};

const hi_event_group_sync_status_progress = /** @type {(inputs: Event_Group_Sync_Status_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Syncing event ${i?.current}/${i?.total}`)
};

const pt_pt2_event_group_sync_status_progress = /** @type {(inputs: Event_Group_Sync_Status_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Syncing event ${i?.current}/${i?.total}`)
};

/**
* | output |
* | --- |
* | "Syncing event {current}/{total}" |
*
* @param {Event_Group_Sync_Status_ProgressInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_sync_status_progress = /** @type {((inputs: Event_Group_Sync_Status_ProgressInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Sync_Status_ProgressInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_group_sync_status_progress(inputs)
	if (locale === "de") return de_event_group_sync_status_progress(inputs)
	if (locale === "it") return it_event_group_sync_status_progress(inputs)
	if (locale === "ru") return ru_event_group_sync_status_progress(inputs)
	if (locale === "es") return es_event_group_sync_status_progress(inputs)
	if (locale === "zh-CN") return zh_cn2_event_group_sync_status_progress(inputs)
	if (locale === "ja") return ja_event_group_sync_status_progress(inputs)
	if (locale === "hi") return hi_event_group_sync_status_progress(inputs)
	if (locale === "pt-PT") return pt_pt2_event_group_sync_status_progress(inputs)
	return en_event_group_sync_status_progress(inputs)
});